<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalConfirmation } from '@shared/ui/modals'

import { useModalKidDelete } from '../../model/modal-kid-delete.hook'

defineOptions({
  name: 'ModalKidDelete',
})

const {
  refIsOpen,
  refIsLoading,
  refKidName,
  closeModal,
  confirmDelete,
} = useModalKidDelete()
</script>

<template>
  <ModalConfirmation
    :show="refIsOpen"
    :loading="refIsLoading"
    :disabled="refIsLoading"
    mode="delete"
    title="Delete kid’s account"
    overlay-class-name="modal-kid-delete"
    @click:confirm="confirmDelete"
    @click:cancel="closeModal"
  >
    <template #content>
      <AppText
        name="body1"
        color="slate-900"
      >
        Are you sure you want to delete
        <AppText
          tag="span"
          name="body1-medium"
          color="slate-900"
        >
          {{ refKidName }}’s
        </AppText>
        account? All data will be permanently removed. This action cannot be undone.
      </AppText>
    </template>
  </ModalConfirmation>
</template>

<style scoped lang="scss" src="./ModalKidDelete.scss" />
